﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListEanvAktionenChoose extends GuiListGeneric {

    constructor() {
        super("GuiListEanvAktionenChoose");
    }

    protected attachListEvents() {
        super.attachListEvents();
       
    }

    clickRow( ): void {
        // keine Funktion in diesem Modul
    }
   

}